export const UPLOAD_IMAGE_FILE = "UPLOAD_IMAGE_FILE";
export const RESET_IMAGE_STORE = "RESET_IMAGE_STORE";
export const BANNER_UPLOADING = "BANNER_UPLOADING";
export const ADVERTORIAL_UPLOADING = "ADVERTORIAL_UPLOADING";
export const POST_IMG_UPLOADING = "POST_IMG_UPLOADING";
